import { Directive, ElementRef, Input } from '@angular/core'

import { GeolocationService } from '../geolocation.service'

@Directive({
  selector: '[cmFormattedAddress]'
})
export class FormattedAddressDirective {

  constructor(private el: ElementRef,
    private geolocationService: GeolocationService) { }

  @Input() set cmFormattedAddress(latLng: number[]) {
    if (!latLng) {
      this.geolocationService.getCurrentPosition()
        .subscribe(position => {
          this.getFormattedAddress(position.coords.latitude, position.coords.longitude)
        })
    } else {
      this.getFormattedAddress(latLng[0], latLng[1])
    }
  }

  private getFormattedAddress(lat: number, lng: number) {
    this.geolocationService.getFormattedAddress(lat, lng)
      .subscribe(address => {
        this.el.nativeElement.innerHTML = address
      })
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/geolocation/formatted-address/formatted-address.directive.ts